import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import LocalStorage from './localStorage';

export const ECO_USER_TIMELINE_TYPE = 52;
const DEFAULT_TEMP = {
  dashboards: {},
};

export const getUserTimelineTempKey = (customerId, userName) =>
  `TEMP-APP-DASHBOARD-${customerId}-${userName}`;

const createTempDashboard = (localStorageKey, type, dashboard, title) => {
  const { dashboards } = LocalStorage.get(localStorageKey) || structuredClone(DEFAULT_TEMP);

  // Try to find an existing dashboard with the same config (deep equality)
  const existingEntry = Object.entries(dashboards).find(([, v]) => {
    const value = v as (typeof dashboards)[string];
    return (
      value.type === type &&
      value.title === (title || `New ${value.id}`) &&
      JSON.stringify(value.dashboard) === JSON.stringify(dashboard)
    );
  });
  if (existingEntry) {
    return existingEntry[0]; // return the existing id (as string)
  }

  const keys = Object.keys(dashboards).filter((key) => /^[0-9]*$/.test(key));
  const numKeys = keys.map(Number).filter((n) => !isNaN(n));
  const id = numKeys.length === 0 ? 1 : Math.max(...numKeys) + 1;

  dashboards[`${id}`] = {
    id: `${id}`,
    title: title || `New ${id}`,
    type,
    dashboard,
    createTime: Date.now(),
    updateTime: Date.now(),
    lastAccessedTime: Date.now(),
    unsaved: true,
  };

  LocalStorage.set({
    key: localStorageKey,
    value: { dashboards },
  });
  return `${id}`;
};

export const createAndGetTempDashboardUrl = (dashboard, localStorageKey) => {
  const { clientId, interval } = dashboard;
  const id = clientId;
  if (clientId) {
    const title = 'Client';
    // create local storage entry
    const tempKey = createTempDashboard(
      localStorageKey,
      ECO_USER_TIMELINE_TYPE,
      { ...dashboard, source: 'emp' },
      `${title} - ${id}`,
    );
    return `${window.location.origin}/app/app-insights/dashboard/user-timeline/temp/${tempKey}?clientId=${clientId}&interval=${interval}`;
  }
  return `${window.location.origin}/app/app-insights/dashboard/user-timeline/temp/?clientId=${clientId}&interval=${interval}`;
};

export const useGoToUserTimeline = () => {
  const { userInfo } = useInitialInfoStore();
  const localStorageKey = getUserTimelineTempKey(userInfo.customer_id, userInfo.username);
  const eventHander = (e, obj) => {
    e.preventDefault();
    const { clientId } = obj;
    if (clientId) {
      // create local storage entry
      const url = createAndGetTempDashboardUrl(obj, localStorageKey);
      window.open(url, '_blank');
    }
  };
  return eventHander;
};
